"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LOCALE = exports.SUPPORTED_LOCALES = void 0;
exports.SUPPORTED_LOCALES = ['zh-CN', 'km-KH', 'en'];
exports.DEFAULT_LOCALE = 'zh-CN';
//# sourceMappingURL=types.js.map